export class DistributorFilter {

  constructor() { }

  name: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/home/models/distributor-filter.ts